var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.calculatedClass,on:{"click":_vm.switchOpen}},[(_vm.isOpened)?_c('div',[_vm._v("×")]):_c('div',[_vm._t("default",function(){return [_c('i',{staticClass:"fa fa-bars"})]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }